<template>
  <a-card :bordered="false">
    <a-spin :spinning="spinning" tip="获取华为云数据中,不建议做其他操作.....">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <div class="div-query-banner">
              <a-form-item label="项目名称">
                <j-multi-select-tag
                  v-model="queryParam.projectNameArrStr"
                  :options="projectOptions"
                  ref="projectNameDictRef"
                  :maxTagCount="2"
                >
                </j-multi-select-tag>
              </a-form-item>
              <a-form-item label="用户名称">
                <j-multi-select-tag
                  v-model="queryParam.handlerArrStr"
                  :options="userOptions"
                  ref="handlerDictRef"
                  :maxTagCount="2"
                >
                </j-multi-select-tag>
              </a-form-item>
              <a-form-item class="btn-200s" label="时间">
                <a-range-picker
                  :allowClear="false"
                  :ranges="timeRanges"
                  show-time
                  :locale="locale"
                  format="YYYY-MM-DD"
                  v-model="timeScope"
                />
              </a-form-item>
              <a-form-item label="状态" >
                <j-dict-select-tag
                  v-model="queryParam.warn"
                  dictCode="huaweiyun_taskstatus"
                  :selectClear="true"
                />
              </a-form-item>

              <a-radio-group
                v-model="queryParam.taskType"
                defaultValue="All"
                class="radio_group"
                button-style="solid"
                @change="loadData(1)"
              >
                <a-radio-button value="All"> All </a-radio-button>
                <a-radio-button value="Task"> Task </a-radio-button>
                <a-radio-button value="Bug"> Bug </a-radio-button>
              </a-radio-group>

              <!-- <a-form-item label="时间">
                <a-radio-group v-model="queryParam.timeType" button-style="solid">
                  <a-radio-button value="周报">
                    周报
                  </a-radio-button>
                  <a-radio-button value="计划">
                    计划
                  </a-radio-button>
                </a-radio-group>
              </a-form-item> -->
              <!-- <a-form-item label="查看类型">
                <a-radio-group v-model="queryParam.orderByFlag" button-style="solid">
                  <a-radio-button :value="1">
                    人员
                  </a-radio-button>
                  <a-radio-button :value="2">
                    项目
                  </a-radio-button>
                </a-radio-group>
              </a-form-item> -->
              <a-button class="query-banner-btn" type="primary" @click="searchQuery">查询</a-button>
              <a-button class="query-banner-btn" type="primary" @click="searchReset">重置</a-button>
            </div>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button class="query-banner-btn color-blue" type="danger" @click="getOurTeamDict(3)">开发三科</a-button>
        <a-button class="query-banner-btn color-blue" type="danger" @click="getOurTeamDict(4)">开发四科</a-button>
        <!-- <a-button class="query-banner-btn color-green" type="danger" @click="handleClickLastWeekReport">上周周报</a-button> -->
        <!-- <a-button class="query-banner-btn color-redz" type="danger" @click="handleClickThisWeekReport">本周周报</a-button>
        <a-button class="query-banner-btn" type="danger" @click="handleClickNextPlan">下周计划</a-button> -->
        <a-radio-group v-model="radioValue" class="radio_group" button-style="solid">
          <a-radio-button @click="handleClickThisWeekReport" value="本周周报"> 本周周报 </a-radio-button>
          <a-radio-button @click="handleClickNextPlan" value="下周计划"> 下周计划 </a-radio-button>
        </a-radio-group>
        <a-button class="query-banner-btn color-gray" type="danger" @click="getNewsData" icon="reload"
          >获取最新数据</a-button
        >
        <span v-if="messageInfo" v-html="messageInfo" type="success" />
        <div class="weeks-num">
          <span style="fontsize: 14px; display: flex; align-items: center">
            <a-avatar :size="20" shape="square" :src="require('@assets/date.png')" class="avatar-box" />
            <span v-if="ifThisWeek">{{ timeScope[0].format('YYYY') }}年第{{ timeScope[0].format('WW') }}周</span>
            <span v-else>
              {{ timeScope[0].format('YYYY') }}年第{{ timeScope[0].format('WW') }}周~{{
                timeScope[1].format('YYYY')
              }}年第{{ timeScope[1].format('WW') }}周
            </span>
          </span>
        </div>
      </div>

      <!-- table区域-begin -->
      <div>
        <a-alert
          class="margin-botton"
          message="计划查询：预计开始时间和预计完成时间在查询时间段内，状态为 (新建,进行中,已解决,测试)中的任务  周报查询：更新时间在查询时间段内的任务(排除预计开始时间在查询结束时间之后，和排除预计结束时间在查询开始时间之前)"
          type="success"
        />
        <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="taskId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :scroll="{ x: 2600 }"
          @change="handleTableChange"
        >
          <template slot="redSpan" slot-scope="text">
            <span class="color-red-cell" v-html="text"></span>
          </template>
          <div slot="warnSlot" slot-scope="text, record">
            <a-spin :spinning="record.statusLoadding">
              <j-dict-select-tag
                placeholder="请选择"
                class="dict-width red"
                :class="{
                  'green-status': text === '正常',
                  'orange-status': text === '预警',
                  'red-status': text === '超时',
                }"
                dictCode="huaweiyun_taskstatus"
                @input="handleStatusChange(record, $event)"
                :value="text"
              ></j-dict-select-tag>
            </a-spin>
          </div>
          <div slot="footer">
            <p class="work-time-p">
              总工时： <span class="red">{{ totalWorkTime }}</span> 小时
            </p>
          </div>
        </a-table>
      </div>
    </a-spin>
    <busWeeklySummary-modal ref="modalForm" @ok="modalFormOk"></busWeeklySummary-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusWeeklySummaryModal from './modules/BusWeeklySummaryModal'
import JMultiSelectTag from '../../components/dict/JMultiSelectTag.vue'
import moment from 'moment'
import { filterObj } from '@/utils/util'
import { getAction } from '@/api/manage'
import { setWarnWeeklySummary } from '@/api/api'
import 'moment/locale/zh-cn'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import { gethHuaYunProjectBatch, hwyHandlerDict, hwyProjectNameDict } from '@/api/api'
export default {
  name: 'BusWeeklySummaryList',
  mixins: [JeecgListMixin],
  components: {
    BusWeeklySummaryModal,
    JMultiSelectTag,
  },
  data() {
    return {
      radioValue: '',
      projectOptions: [{}],
      userOptions: [{}],
      description: 'bus_weekly_summary管理页面',
      list: [],
      // 表头
      columns: [
        {
          title: '序号',
          align: 'center',
          fixed: 'left',
          dataIndex: 'index',
          width: '50px',
        },
        {
          title: '项目名称',
          align: 'center',
          dataIndex: 'projectName',
          fixed: 'left',
          width: '150px',
          scopedSlots: {
            customRender: 'fontWeight',
          },
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.projectNameRowSpan,
                class: 'font-weight-bolder',
              },
            }
          },
        },
        {
          title: '任务名称',
          align: 'center',
          fixed: 'left',
          dataIndex: 'taskName',
          width: '350px',
        },
           {
          title: 'epic',
          align: 'center',
          dataIndex: 'epicName',
          fixed: 'left',
          width: '150px',
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.epicNameRowSpan,
              },
            }
          },
        },
        {
          title: '任务类型',
          align: 'center',
          dataIndex: 'taskType',
          width: '100px',
        },
        {
          title: '任务状态',
          align: 'center',
          dataIndex: 'taskStatus',
          width: '100px',
        },
        {
          title: '处理人',
          align: 'center',
          dataIndex: 'handler',
          width: '100px',
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.handlerRowSpan,
              },
            }
          },
        },
        {
          title: '进度(%)',
          align: 'center',
          dataIndex: 'doneRatio',
          width: '100px',
          scopedSlots: {
            customRender: 'redSpan',
          },
        },
        {
          title: '预计开始日期',
          align: 'center',
          dataIndex: 'beginTime',
          width: '150px',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '预计结束日期',
          align: 'center',
          dataIndex: 'endTime',
          width: '150px',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '实际工时(h)',
          align: 'center',
          dataIndex: 'actualWorkHours',
          width: '100px',
          scopedSlots: {
            customRender: 'redSpan',
          },
        },
        {
          title: '迭代',
          align: 'center',
          width: '150px',
          dataIndex: 'iteration',
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.iterationRowSpan,
              },
            }
          },
        },
     
        {
          title: 'feature',
          align: 'center',
          dataIndex: 'featureName',
          width: '150px',
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.featureNameRowSpan,
              },
            }
          },
        },
        {
          title: 'story',
          align: 'center',
          dataIndex: 'storyName',
          // width: '150px',
          customRender(text, row) {
            return {
              children: text,
              attrs: {
                rowSpan: row.storyNameRowSpan,
              },
            }
          },
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          width: '150px',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime',
          width: '150px',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'warn',
          width: '150px',
          fixed: 'right',
          scopedSlots: { customRender: 'warnSlot' },
        },
      ],
      url: {
        list: '/org/jeecg/busWeeklySummary/selectList',
        delete: '/org/jeecg/busWeeklySummary/delete',
        deleteBatch: '/org/jeecg/busWeeklySummary/deleteBatch',
        exportXlsUrl: '/org/jeecg/busWeeklySummary/exportXls',
        importExcelUrl: 'org/jeecg/busWeeklySummary/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
      timeRanges: {
        上周: [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        本周: [moment().startOf('week'), moment().endOf('week')],
        下周: [moment().add(1, 'week').startOf('week'), moment().add(1, 'week').endOf('week')],
      },
      locale,
      timeScope: [moment().startOf('week'), moment().endOf('week')],
      spinning: false,
      ifThisWeek: false, //是否只有一周
      messageInfo: '',
      totalWorkTime: 0,
    }
  },
  created() {
    console.log(this.timeScope)
    // alert(moment().subtract(1, 'week').startOf('week').format("YYYY-MM-DD"))
    // alert(moment().endOf('week').format("WW"));
    // alert(moment().subtract(1, 'week').endOf('week').format("YYYY-MM-DD"));
  },
  mounted() {
    this.getProjectNameDict()
    this.getHanderDict()
    this.initQuery()
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  watch: {
    timeScope: {
      immediate: true,
      handler(val) {
        console.log(val)
        console.log(val[0].format('YYYY') + 'wwww' + val[1].format('YYYY'))
        console.log(val[0].format('WW') + 'wwwww' + val[1].format('WW'))
        let difference = val[1].diff(val[0], 'days')
        if (
          (val[0].format('YYYY') == val[1].format('YYYY') && val[0].format('WW') == val[1].format('WW')) ||
          (val[0].format('WW') == val[1].format('WW') && difference < 10)
        ) {
          this.ifThisWeek = true
        } else {
          this.ifThisWeek = false
        }
        this.radioValue = ''
        this.queryParam.timeType = '周报'
      },
    },
  },
  methods: {
    handleStatusChange(record, newValue) {
      if (!newValue) {
        this.$message.error('状态必须输入！')
        return
      }
      record.statusLoadding = true
      setWarnWeeklySummary({ taskId: record.taskId, warn: newValue })
        .then((res) => {
          if (res.success) {
            record.warn = newValue
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.$message.error(err.message)
          } else {
            this.$message.error(err)
          }
        })
        .finally(() => {
          record.statusLoadding = false
        })
    },
    getHanderDict() {
      hwyHandlerDict().then((res) => {
        if (res.code == 200) {
          //去掉禁用的
          let arrTemp = res.result.filter((item) => {
            return !item.forbidden
          })
          //去重
          let map = new Map()
          for (let item of arrTemp) {
            if (!map.has(item.name)) {
              map.set(item.name, item)
            }
          }
          //给下拉框复制
          this.userOptions = [...map.values()].map((item) => ({
            text: item.name,
            value: item.value,
            forbidden: item.forbidden,
          }))
        }
      })
    },
    getProjectNameDict() {
      hwyProjectNameDict().then((res) => {
        if (res.code == 200) {
          this.projectOptions = res.result.map((item) => ({
            text: item.name,
            value: item.value,
          }))
        }
      })
    },
    getNewsData() {
      this.spinning = true
      gethHuaYunProjectBatch()
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.radioValue = ''
            this.loadData(1)
          }
        })
        .finally(() => {
          this.spinning = false
        })
    },
    handleClickLastWeekReport() {
      this.timeScope = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')]
      this.queryParam.timeType = '周报'
      this.loadData(1)
    },
    handleClickThisWeekReport() {
      this.timeScope = [moment().startOf('week'), moment().endOf('week')]
      this.queryParam.timeType = '周报'
      this.loadData(1)
    },
    handleClickNextPlan() {
      this.timeScope = [moment().add(1, 'week').startOf('week'), moment().add(1, 'week').endOf('week')]
      this.queryParam.timeType = '计划'
      this.loadData(1)
    },
    searchReset() {
      this.timeScope = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')]
      this.initQuery()
      this.loadData(1)
    },
    initQuery() {
      this.queryParam = {}
      this.$set(this.queryParam, 'orderByFlag', 2)
      this.$set(this.queryParam, 'taskType', 'All')
      this.$set(this.queryParam, 'timeType', '周报')
    },
    getOurTeamDict(numberType) {
      let arr = this.projectOptions.map((item) => {
        return item.value
      })
      switch (numberType) {
        case 3:
          this.$set(
            this.queryParam,
            'handlerArrStr',
            '蒋波,洪加华,纪鑫建,叶文清,郑阿超,庄南强,叶志航,谢春辉,杨钰梅,蔡炜璎'
          )
          break
        case 4:
          this.$set(this.queryParam, 'handlerArrStr', '杨宇航,叶辉煌,胡志鸿,郑天才')
          break
        default:
          break
      }
      this.$set(this.queryParam, 'projectNameArrStr', arr.join(','))
      this.loadData(1)
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
      }
      switch (this.queryParam.timeType) {
        case '周报':
          this.queryParam.hwBeginTime = ''
          this.queryParam.hwEndTime = ''
          this.queryParam.beginUpdatedTime = this.timeScope[0].format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.endUpdatedTime = this.timeScope[1].format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.taskStatusArrStr = ''
          break
        case '计划':
          this.queryParam.beginUpdatedTime = ''
          this.queryParam.endUpdatedTime = ''
          this.queryParam.hwBeginTime = this.timeScope[0].format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.hwEndTime = this.timeScope[1].format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.taskStatusArrStr = '进行中,已解决,测试中,新建'
          break
        default:
          this.$message.error('请选择日期')
          return
          break
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters, { oldFlag: 1 })
      delete param.timeType
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      this.dataSource = []
      this.totalWorkTime = 0
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          let sourceTemp = res.result.records.map((item, index, datas) => {
            return {
              ...item,
              index: index + 1,
            }
          })
          sourceTemp.forEach((element) => {
            this.$set(element, 'statusLoadding', false)
            this.$set(element, 'warn', element.warn ? element.warn : undefined)
          })
          this.dataSource = sourceTemp
          this.rowSpan('projectName')
          this.rowSpan('handler')
          this.rowSpan('iteration')
          this.rowSpan('epicName')
          this.rowSpan('featureName')
          this.rowSpan('storyName')
          if (res.message) {
            let messageArr = res.message.split('?')
            this.totalWorkTime = messageArr[0] ? messageArr[0] : 0
            this.messageInfo = messageArr[1] ? messageArr[1] : ''
          }
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
      // 避免下周计划后 监听日期延时触发timeType == "周报" 下一页bug
      if (this.queryParam.timeType == '计划') {
        this.$nextTick(() => {
          this.queryParam.timeType = '计划'
        })
      }
    },
    rowSpan(key) {
      let arr = this.dataSource.map((item, index, datas) => {
        if (index != 0) {
          if (item[key] == datas[index - 1][key]) {
            return {
              ...item,
              [`${key}RowSpan`]: 0,
            }
          }
        }
        let count = 1
        for (let j = index; j < datas.length - 1; j++) {
          if (item[key] === datas[j + 1][key]) {
            count++
          } else {
            break
          }
        }
        return {
          ...item,
          [`${key}RowSpan`]: count,
        }
      })
      this.dataSource = arr
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';

.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  /deep/ .ant-select-selection__rendered {
    width: 235px;

    .ant-select-selection__choice {
      .ant-select-selection__choice__content {
        span {
          width: 42px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  & > *:nth-child(1) {
    min-width: 300px;
    max-width: 340px;
  }

  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }

  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }

  .btn-widths {
    width: 200px !important;
  }

  .btn-200s {
    width: 270px !important;

    .ant-calendar-picker {
      width: 210px !important;
    }
  }
}

.table-operator {
  .radio_group {
    margin-right: 8px;
  }
}

.color-red-cell {
  color: red;
}

.margin-botton {
  margin-bottom: 10px;
}

.color-blue {
  color: #ff7500;

  &:hover {
    color: #fff !important;
    background-color: #ff7500 !important;
    border-color: #ff7500 !important;
  }
}

.color-gray {
  color: #808080;

  &:hover {
    color: #fff !important;
    background-color: #808080 !important;
    border-color: #808080 !important;
  }
}

.color-green {
  color: #96ce54;

  &:hover {
    color: #fff !important;
    background-color: #96ce54 !important;
    border-color: #96ce54 !important;
  }
}

.color-redz {
  color: #c32136;

  &:hover {
    color: #fff !important;
    background-color: #c32136 !important;
    border-color: #c32136 !important;
  }
}

/deep/.font-weight-bolder {
  font-weight: bolder;
}
.weeks-num {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  height: 32px;
}
.avatar-box {
  margin-right: 3px;
}
.dict-width {
  width: 100px;
}
.work-time-p {
  text-align: right;
  .red {
    color: red;
  }
}
.green-status {
  color: green;
}
.orange-status {
  color: orange;
}
.red-status {
  color: red;
}
</style>